const currentlyEmployedSelector = state => state.builder.ui.currentlyEmployed;

export default currentlyEmployedSelector;
